import { Alert, CircularProgress } from "@mui/material";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import Grid2 from "@mui/material/Unstable_Grid2";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import MKBox from "../../components/MKBox";
import AssetCard from "../Cards/AssetCard";
import GridCard from "../Cards/GridCard";

const GridCardAssetsData = ({ map }) => {
  const { items } = useSelector((state) => state.returnItems);
  const { submitClicked } = useSelector((state) => state.dataSelection);

  const [activeTab, setActiveTab] = useState(0);
  useEffect(() => {
    setActiveTab(items.length !== 0 ? items[0].id : 0);
  }, [items]);

  const handleTabValue = (e, value) => setActiveTab(value);

  const parentRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(null);

  useLayoutEffect(() => {
    if (parentRef.current) {
      const parentHeight = parentRef.current.offsetHeight;
      const titleHeight = parentRef.current ? parentRef.current.children[0].offsetHeight : 50;
      setMaxHeight(parentHeight - titleHeight - 36 - 48);
    }
  }, [parentRef]);

  const tabs =
    items.length !== 0 ? (
      <MKBox sx={{ width: 1, borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={activeTab}
          onChange={handleTabValue}
          variant={items.length > 4 ? "scrollable" : "fullWidth"}
          scrollButtons={items.length > 4}
          textColor="secondary"
          indicatorColor="secondary"
          sx={{ minHeight: 24, padding: 0 }}
        >
          {items
            .sort((a, b) => {
              const idA = a.id;
              const idB = b.id;
              if (idA < idB) {
                return -1;
              }
              if (idA > idB) {
                return 1;
              }
              return 0;
            })
            .map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Tab key={item.id + index} label={item.id} value={item.id} />
            ))}
        </Tabs>
      </MKBox>
    ) : null;

  if (submitClicked) {
    return (
      <>
        <GridCard title="Assets">
          <MKBox sx={{ height: 1, m: { lg: 0, xl: 1 } }}>
            <Grid2 container xs={12} sx={{ m: 1, justifyContent: "center" }}>
              <CircularProgress />
            </Grid2>
          </MKBox>
        </GridCard>
      </>
    );
  }
  return (
    <>
      <GridCard title="Assets" ref={parentRef}>
        {tabs}
        <MKBox sx={{ height: 1, m: { lg: 0.5, xxl: 1, xxxl: 2 } }}>
          <Grid2
            container
            xs={12}
            sx={{ m: { lg: 0.5, xxl: 1, xxxl: 2 }, justifyContent: "center" }}
          >
            {items.length !== 0 && activeTab !== 0 ? (
              <>
                <Grid2 maxHeight={maxHeight} sx={{ width: "95%", overflow: "auto" }}>
                  {items.filter((item) => item.id === activeTab)[0].features.length > 0 ? (
                    items
                      .filter((item) => item.id === activeTab)[0]
                      .features.map((feature) => (
                        <Grid2 xs={12} key={feature.id}>
                          <AssetCard feature={feature} map={map} />
                        </Grid2>
                      ))
                  ) : (
                    <Alert severity="warning" onClose={() => {}}>
                      There is no assets — check your AOI!
                    </Alert>
                  )}
                </Grid2>
              </>
            ) : null}
          </Grid2>
        </MKBox>
      </GridCard>
    </>
  );
};
GridCardAssetsData.defaultProps = {
  map: null,
};

GridCardAssetsData.propTypes = {
  map: PropTypes.oneOfType([PropTypes.any]),
};
export default GridCardAssetsData;
